import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  CollegeSettings_LIST_START: "CollegeSettings_LIST_START",
  CollegeSettings_LIST_SUCCESS: "CollegeSettings_LIST_SUCCESS",
  CollegeSettings_LIST_FAILED: "CollegeSettings_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const CollegeSettingsListStart = (data) => ({
  type: actionType.CollegeSettings_LIST_START,
  payload: data,
});

export const CollegeSettingsListSuccess = (data) => ({
  type: actionType.CollegeSettings_LIST_SUCCESS,
  payload: data,
});

export const CollegeSettingsListFailed = (data) => ({
  type: actionType.CollegeSettings_LIST_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function CollegeSettingsListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.CollegeSettings_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.CollegeSettings_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.CollegeSettings_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* CollegeSettingsListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      const allCollegeSettings = response.data.data.allCollegesettings?.Collegesettings
        ? response.data.data.allCollegesettings.Collegesettings
        : null;
      let finalData = [];
      yield put(CollegeSettingsListSuccess(allCollegeSettings));
    } else {
      messagePopup("", "COLLEGE List failed", "error");
      yield put(CollegeSettingsListFailed("CollegeSettings List failed"));
    }
  } catch (error) {
    messagePopup("", "CollegeSettings List failed", "error");
    yield put(CollegeSettingsListFailed("CollegeSettings List failed"));
  }
}

export function* watchCollegeSettingsListSaga() {
  yield takeEvery(actionType.CollegeSettings_LIST_START, CollegeSettingsListSaga);
}
